var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCaradano(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 60 60",
    style: {
      enableBackground: "new 0 0 60 60"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\t.st0{fill:#ff3131;}")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M24.7,30c0,2.2-1.7,4-3.8,4s-3.8-1.7-4-3.8c0-2.2,1.6-4,3.8-4C22.8,26,24.5,27.8,24.7,30z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M25.2,33.8c2.2,0,4,1.7,4,3.8c0,2.1-1.7,3.8-3.8,3.8c-2.2,0-4-1.7-4-3.8C21.2,35.6,22.9,33.8,25.2,33.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M21.3,22.4c0-2.2,1.6-4,3.8-4s4,1.6,4,3.8c0,2.1-1.7,4-4,4C23.1,26.2,21.3,24.4,21.3,22.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M34.1,33.8c2.2,0,4,1.7,4,3.8c0,2.1-1.7,3.8-3.8,4c-2.2,0-4-1.7-4-4C30.1,35.6,31.8,33.8,34.1,33.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M34.5,29.9c0-2.2,1.9-3.8,4.1-3.7c2.1,0,3.7,1.9,3.7,4s-1.9,3.8-4,3.8C36.3,33.7,34.5,31.9,34.5,29.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M34.1,18.4c2.1,0,3.8,1.7,3.8,3.8s-1.9,4-4,4s-3.8-1.7-3.8-3.8C30.1,20.2,31.8,18.4,34.1,18.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M42.8,39.9c-1.3,0-2.4-1.1-2.4-2.4c0-1.3,1.1-2.4,2.4-2.4s2.4,1.1,2.2,2.4C45,38.8,43.9,39.9,42.8,39.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M18.8,22.4c0,1.3-1.1,2.4-2.2,2.4c-1.1,0-2.4-1.1-2.4-2.2c0-1.3,1.1-2.4,2.4-2.4C17.7,20,18.8,21.1,18.8,22.4z  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M29.4,42.9c1.3,0,2.4,1.1,2.4,2.2c0,1.3-1.1,2.4-2.4,2.4c-1.3,0-2.2-1.1-2.2-2.4  C27.2,43.8,28.2,42.9,29.4,42.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M18.8,37.6c0,1.3-1,2.2-2.2,2.4c-1.3,0-2.4-1.1-2.4-2.4s1.1-2.2,2.4-2.2C17.7,35.3,18.8,36.4,18.8,37.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M29.4,17.1c-1.3,0-2.2-1.1-2.2-2.4s1.1-2.4,2.2-2.4c1.3,0,2.4,1.1,2.4,2.4S30.7,17.1,29.4,17.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M45,22.4c0,1.3-1,2.2-2.2,2.2c-1.3,0-2.4-1-2.4-2.2s1-2.2,2.2-2.2C44.1,20,45,21,45,22.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M41.5,47c0,1.1-1,1.9-2.1,1.9c-1.1,0-2.1-1-1.9-2.1c0-1.1,1-1.9,2.1-1.9C40.6,45.1,41.5,45.9,41.5,47z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12,30c0,1.1-1,2.1-2.1,1.9c-1.1,0-1.9-1-1.9-2.1s1-1.9,2.1-1.9C11,28.1,12,29.1,12,30z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M49.3,31.9c-1.1,0-2.1-1-1.9-1.9c0-1.1,1-1.9,2.1-1.9c1.1,0,1.9,1,1.9,2.1C51.2,31.1,50.4,31.9,49.3,31.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M41.4,12.8c0,1.1-0.8,2.1-1.9,2.1c-1.1,0-2.1-1-2.1-2.1c0-1,1-2.1,2.1-2.1C40.6,10.9,41.4,11.7,41.4,12.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M19.8,48.9c-1.1,0-1.9-0.8-1.9-1.9c0-1.1,1-2.1,1.9-1.9c1.1,0,1.9,1,2.1,2.1C21.8,48.1,20.9,48.9,19.8,48.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M19.8,10.9c1.1,0,2.1,0.8,2.1,1.9s-1,2.1-1.9,2.1c-1.1,0-2.1-1-2.1-1.9C17.7,11.9,18.5,10.9,19.8,10.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M31.2,5.7c0,1-0.8,1.6-1.7,1.6s-1.6-0.8-1.6-1.7s0.8-1.6,1.6-1.6C30.4,4.1,31.2,4.9,31.2,5.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M29.4,52.6c1,0,1.6,0.8,1.6,1.7c0,1-0.6,1.6-1.6,1.6c-1,0-1.7-0.6-1.7-1.6C27.9,53.4,28.7,52.6,29.4,52.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8.6,43.7c-1,0-1.7-0.6-1.7-1.6s0.8-1.7,1.6-1.7c0.8,0,1.6,0.8,1.6,1.7C10.2,43,9.6,43.7,8.6,43.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M52.2,42.1c0,1-0.8,1.7-1.6,1.7c-0.8,0-1.7-0.8-1.6-1.7c0-0.8,0.8-1.6,1.6-1.6C51.5,40.3,52.2,41.1,52.2,42.1z  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10.2,17.9c0,1-0.8,1.7-1.6,1.7c-1,0-1.6-0.8-1.6-1.7s0.6-1.6,1.6-1.6C9.4,16.2,10.2,17,10.2,17.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M50.4,19.4c-1,0-1.6-0.8-1.6-1.7s1-1.6,1.7-1.6c0.8,0,1.6,0.8,1.6,1.6C52.2,18.7,51.4,19.4,50.4,19.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M43.1,54.3c-0.6,0-1.4-0.6-1.4-1.3c0-0.6,0.6-1.4,1.3-1.4c0.8,0,1.3,0.5,1.3,1.3  C44.4,53.7,43.8,54.3,43.1,54.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M57.6,29.9c0,0.8-0.6,1.4-1.3,1.4c-0.8,0-1.3-0.5-1.3-1.3c0-0.6,0.6-1.4,1.3-1.3  C57.1,28.6,57.6,29.1,57.6,29.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16.3,8.2c-0.6,0-1.4-0.6-1.3-1.3c0-0.8,0.5-1.3,1.3-1.3c0.8,0,1.3,0.5,1.3,1.3C17.5,7.4,16.9,8.2,16.3,8.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2.9,31.3c-0.6,0-1.4-0.6-1.3-1.3c0-0.8,0.5-1.3,1.3-1.3s1.3,0.5,1.3,1.3C4.3,30.6,3.5,31.3,2.9,31.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M42.8,5.5c0.8,0,1.4,0.6,1.3,1.4c0,0.8-0.5,1.3-1.3,1.3c-0.8,0-1.3-0.6-1.3-1.4C41.7,5.9,42.2,5.5,42.8,5.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16.4,51.8c0.6,0,1.1,0.5,1.1,1.3c0,0.8-0.6,1.4-1.3,1.3c-0.8,0-1.3-0.5-1.3-1.3C15,52.4,15.6,51.8,16.4,51.8z  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaradano);
export default __webpack_public_path__ + "static/media/caradano.5e331fd5c5bdfef9eb631102a8f4a90c.svg";
export { ForwardRef as ReactComponent };